// Theme configuration with Verizon and Opplane colors
const theme = {
  colors: {
    // Verizon colors
    verizonRed: '#CD040B',
    verizonBlack: '#000000',
    verizonWhite: '#FFFFFF',
    
    // Opplane colors
    opplaneBlue: '#0066CC',
    opplaneDarkBlue: '#004080',
    opplaneGray: '#F5F5F5',
    
    // Combined palette
    primary: '#0066CC',     // Opplane Blue
    secondary: '#0066CC',   // Opplane Blue
    background: '#F5F5F5',  // Light Gray
    text: '#000000',        // Black
    lightText: '#666666',   // Gray
    border: '#DDDDDD',      // Light Gray
    success: '#28A745',     // Green
    warning: '#FFC107',     // Yellow
    error: '#DC3545',       // Red
    info: '#17A2B8',        // Cyan
  },
  fonts: {
    primary: "'Roboto', 'Helvetica Neue', sans-serif",
  },
  fontSizes: {
    small: '0.875rem',
    medium: '1rem',
    large: '1.25rem',
    xlarge: '1.5rem',
    xxlarge: '2rem',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    small: '0.25rem',
    medium: '0.5rem',
    large: '1rem',
    circle: '50%',
  },
  shadows: {
    small: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    medium: '0 3px 6px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.12)',
    large: '0 10px 20px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.10)',
  },
  transitions: {
    short: 'all 0.2s ease-in-out',
    medium: 'all 0.3s ease-in-out',
    long: 'all 0.5s ease-in-out',
  },
};

export default theme;
